/** @namespace routes */
import { register } from 'tmr/tmr/ngModuleRegistry'

import './settings'

import * as admin from './admin'
import * as alerts from './alerts/alerts'
import * as alertsForm from './alerts/form'
import * as hierarchies from './hierarchies/hierarchies'
import * as hierarchiesForm from './hierarchies/form'
import * as hierarchiesSort from './hierarchies/hierarchies.sort'
import * as places from './places/places'
import * as placesForm from './places/form'
import * as productionWorkflows from './productionWorkflows/productionWorkflows'
import * as productionWorkflowsForm from './productionWorkflows/form'
import * as roles from './roles/roles'
import * as rolesCapabilities from './roles/roles.capabilities'
import * as rolesForm from './roles/form'
import * as userPassword from './users/user.password'
import * as users from './users/users'
import * as usersForm from './users/form'
import * as zones from './zones/zones'
import * as zonesForm from './zones/form'
import * as user from './self/self'
import * as userForm from './self/form'

export default register(
  'tmr.core.routes.admin',
  admin,
  alerts,
  alertsForm,
  hierarchies,
  hierarchiesForm,
  hierarchiesSort,
  places,
  placesForm,
  productionWorkflows,
  productionWorkflowsForm,
  roles,
  rolesCapabilities,
  rolesForm,
  users,
  usersForm,
  user,
  userForm,
  userPassword,
  zones,
  zonesForm
)
